import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Button as LoftButton } from "@xometry/xometry_loft";

export const Button = styled(LoftButton)`
  margin-right: ${theme.space[3]};
  padding: ${theme.spacing[3]} ${theme.spacing[7]};
`;

export const FormContainer = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;

export const FormSuccessContainer = styled.div`
  max-width: 400px;
  padding: ${theme.spacing[4]};
  margin: 0 auto;
  border-radius: ${theme.spacing[2]};
  overflow: hidden;
  background-color: ${theme.colors.white};
`;

export const FormComponent = styled.div`
  min-height: 400px;

  ${theme.largerThan.xl} {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9998;
    display: grid;
    align-content: center;
  }
`;

export const FormMicroComponentContainer = styled.div`
  display: grid;
  border-radius: ${theme.borderRadius};
  overflow: auto;
  min-height: 650px;
  background-color: ${theme.colors.white};

  ${theme.largerThan.md} {
    min-height: 500px;
    box-shadow: ${theme.boxShadow.small};
  }
`;

export const FormDisclaimer = styled.div`
  margin-top: ${theme.spacing[2]};
  font-size: ${theme.fontSizes[0]};
  color: ${theme.colors.grays[5]};
`;

export const SalesforceContactFormWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: ${theme.spacing[20]} ${theme.spacing[4]} ${theme.spacing[4]};
  background-color: ${theme.colors.darkBlues[100]}cc;
  z-index: 100;
  overflow: auto;

  ${theme.largerThan.md} {
    display: grid;
    justify-items: center;
    align-content: center;
  }
`;
